import { render, staticRenderFns } from "./sendPaymentLink.vue?vue&type=template&id=212259a5"
import script from "./sendPaymentLink.vue?vue&type=script&lang=js"
export * from "./sendPaymentLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports